/* eslint-disable prettier/prettier */
import { UploadCloud, X } from 'lucide-react';
import { FaFileExcel } from 'react-icons/fa';

interface Props {
  fileName: string | null;
  uploadStatus: 'idle' | 'uploading' | 'error' | 'success';
  onUploadClick?: () => void;
  onRemoveFile: () => void;
  onFileSelect: (file: File) => void;
  onClickFile?: () => void;
}

export const ExcelUploadZone = ({
  fileName,
  uploadStatus,
  onUploadClick,
  onRemoveFile,
  onFileSelect,
  onClickFile,
}: Props) => {
  const allowedTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return;
    const file = e.target.files[0];
    if (!allowedTypes.includes(file.type)) return;
    onFileSelect(file);
  };

  if (fileName) {
    return (
      <div className="flex items-center justify-between w-full px-4 py-3 overflow-auto border rounded-xl border-secondary">
        <div className="flex items-center gap-3 w-[85%] hover:cursor-pointer" onClick={onClickFile}>
          <FaFileExcel className="w-6 h-6 text-green-600" />
          <p className="text-sm font-semibold truncate text-primary">{fileName}</p>
        </div>
        <div className="flex items-center gap-2">
          {(uploadStatus === 'idle' || uploadStatus === 'error') && onUploadClick && fileName && (
            <button
              onClick={onUploadClick}
              className="text-green-500 hover:text-green-600"
              title="Upload file"
            >
              ✔
            </button>
          )}
          <button
            onClick={onRemoveFile}
            className="text-red-500 hover:text-red-600"
            title="Remove file"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <label className="flex flex-col items-center justify-center gap-1 p-6 mt-3 text-center transition border-2 border-dashed cursor-pointer rounded-2xl border-secondary hover:bg-highlight">
      <UploadCloud className="w-6 h-6 mb-2 text-primary" />
      <p className="text-sm text-gray-600">
        Drag and drop Excel/CSV file here, or{' '}
        <span className="underline text-primary hover:text-primary">Choose file</span>
      </p>
      <input type="file" accept=".xls,.xlsx,.csv" className="hidden" onChange={handleChange} />
    </label>
  );
};
